import {
  EventNamesSupplier,
  EventNamesPayment,
  Platforms,
  Scopes,
  ScopesPayment,
} from 'constants/events/mixpanel'
import { analyticsMerchant, analyticsSupplier } from 'modules/analytics'

export type EventProperties = Record<string, unknown> | undefined

export type SendSalespersonEventArgs = EventProperties & {
  platform: Platforms
  scope: Scopes
  eventName: EventNamesSupplier
}

export type SendMerchantEventArgs = EventProperties & {
  platform: Platforms
  scope: ScopesPayment
  eventName: EventNamesPayment
}

export function useAnalyticsSupplier() {
  return function sendEvent({
    scope,
    platform,
    eventName,
    ...properties
  }: SendSalespersonEventArgs) {
    analyticsSupplier.track(`${scope}__${eventName}`, {
      scope,
      platform,
      ...properties,
    })
  }
}

export function useAnalyticsMerchant() {
  return function sendEvent({
    scope,
    platform,
    eventName,
    ...properties
  }: SendMerchantEventArgs) {
    analyticsMerchant.track(`${scope}__${eventName}`, {
      scope,
      platform,
      ...properties,
    })
  }
}
